import { render } from "./EmpLeads.vue?vue&type=template&id=5ab40856"
import script from "./EmpLeads.vue?vue&type=script&lang=js"
export * from "./EmpLeads.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__